module.exports = __webpack_public_path__ + "img/landscape-1.78c19f12.png";